import { Navigate } from "react-router-dom";
import MontacargasLayout from "./layout/MontacargasLayout";
import MontacargasLogin from "./login/login";
import MontacargasHome from "./home/home";
import RequireLiftSession from "./RequireLiftSession";

export const montacargasRoute = {
  path: "/montacargas",
  element: <MontacargasLayout />,
  children: [
    { index: true, element: <MontacargasLogin /> },
    {
      path: "home",
      element: (
        <RequireLiftSession>
          <MontacargasHome />
        </RequireLiftSession>
      ),
    },
    { path: "*", element: <Navigate to="/montacargas" replace /> },
  ],
};
